import React from "react";
import IconButton from "@mui/material/IconButton";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import LimitExceeded from "../LimitExceeded";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CircularProgress from "@mui/material/CircularProgress";
import { Button } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

function Progress(props) {
  const { open, handleClose } = props;

  return (
    <React.Fragment>
      <style>
        {`
        .loader {
          background: #ffffff;
          bottom: 0;
          left: 0;
          opacity: 0.8;
          right: 0;
          top: 0;
      }
      
      .loader,
      .loader-content {
          display: flex;
          align-items: center;
          justify-content: center;
      }
      
      .loader-message {
          font-size: 2.5em;
          margin-top: 1em;
      }
      `}
      </style>
      <Dialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
        <DialogContent
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <DialogContentText id="alert-dialog-description">
            <div className="loader">
              <CircularProgress />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default function CustomizedDialogs(props) {
  const { InstanceID, status, spent, budget, billingtype } = props;
  const [budgetopen, setBudgetOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to start a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
    setPopUpOpen(false);
  };
  

  const handleSubmitClick = (e) => {
    e.preventDefault();
    setOpen(true);
    let balance = parseInt(budget) - parseInt(spent);
    let available = localStorage.getItem("available");
    let verify_Balance_Status = "false"
    if (billingtype === "hourlybased") {
      verify_Balance_Status = "false"
    }
    else {
      if (available > balance && balance > 0) {
        verify_Balance_Status = "false"
      }
      else {
        verify_Balance_Status = "true"
      }
    }
    if (verify_Balance_Status === "false") {
      fetch(`${process.env.REACT_APP_API_URL}/api/startsvmlab/${InstanceID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setOpen(false);
            // window.location.reload();
            if (data === "Success") {
              setOpen1(false);
              window.location.reload();
            }
            else {
              setOpen1(true);
              setOpentitle(data);
            }
          } else {
            if (data.name) {
              setOpen1(false);
              setState({ errorMessage: data.name[0] });
            }
          }
        })
        .catch((error) => {
          setOpen1(false);
          window.location.reload();
        });
    } else {
      setBudgetOpen(true);
    }
  };

  return (
    <div>
      <Dialog
            open={popupopen}
            onClose={handlePopUpClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
            {popupopentitle} {" "}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description"></DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handlePopUpClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleSubmitClick} color="primary">
                Ok
              </Button>
            </DialogActions>
      </Dialog>
      <Dialog
          open={open1}
          onClose={handleClose1}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose1} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      <Progress open={open} handleClose={handleClose} />
      <LimitExceeded
        validerroropen={budgetopen}
        setvaliderroropen={setBudgetOpen}
      />
      {status === "Stopped" ? (
        <React.Fragment>
          <MenuItem onClick={handleOpen}>
            <IconButton aria-label="Filter" color="primary" onClick={handleOpen}>
              <PlayArrowTwoToneIcon /> &nbsp;&nbsp;
              <span style={{ fontSize: "0.7em", color: "#172B4D" }}>Start</span>
            </IconButton>
          </MenuItem>
        </React.Fragment>
      ) : (
        ""
      )}
    </div>
  );
}